import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import React, { useState, useEffect } from 'react';

interface DataType {
  [key: string]: string | number;
}

interface TableDataOutput {
  TableData: {
    Columns: {
      title: string;
      isFixed: boolean;
      type: 'text' | 'progress' | 'plan' | 'number';
      cells: string[];
    }[];
    hasMakeFavorite: boolean;
  };
}

const BreakOutsTable: React.FC<TableDataOutput> = ({ TableData }) => {
  const [columns, setColumns] = useState<ColumnsType<DataType>>([]);

  useEffect(() => {
    setColumns(
      TableData.Columns.map((item, i) => ({
        title: Date.parse(item.title)
          ? moment(item.title).local(false).locale('en').format('DD-MM-YYYY')
          : item.title,
        dataIndex: item.title,
        key: item.title + i,
        fixed: item.isFixed,
      }))
    );
  }, [TableData]);

  const getData = () => {
    const data: DataType[] = [];

    TableData.Columns.forEach((item) => {
      item.cells.forEach((element: string, i: number) => {
        if (data[i]) {
          data[i] = { ...data[i], key: i, [item.title]: element };
        } else {
          data[i] = { [item.title]: element, key: i };
        }
      });
    });
    return data;
  };
  return (
    <Table
      columns={columns}
      pagination={false}
      dataSource={getData()}
      scroll={{ x: 500, y: 400 }}
    />
  );
};

export default BreakOutsTable;
